<div id="add-report-items-modal" class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Please enter the address to send the report</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>

    <div class="ttmodal__body">

            <div class="section-content" style="padding-bottom: 24px;">
                <span >Customer Name:</span> 
                <input type="text" [(ngModel)]="customerName"   [formControl]="customerNameInput" placeholder="Name" />     
                <span style="margin-left: 5px;font-size: 16px;" *ngIf="customerNameInput.errors && (customerNameInput.dirty || customerNameInput.touched)">
                        <mat-error style="color:red" *ngIf="customerNameInput.errors.required">Customer Name is required</mat-error>
                </span>           
            </div>

        <div class="section-content" style="padding-bottom: 24px;">
            <span>Email:</span> 
            <input type="text" [(ngModel)]="emailAddress"  (keyup)="checkEmailAddress()"  [formControl]="emailInput" placeholder="Email" />
           
            <span style="margin-left: 5px;font-size: 16px; color: red" *ngIf="!validEmailString && emailAddress?.length > 0">Please enter a valid email address.</span> 
            <span style="margin-left: 5px;font-size: 16px;" *ngIf="emailInput.errors && (emailInput.dirty || emailInput.touched)">
                    <mat-error style="color:red" *ngIf="emailInput.errors.required">Email Address is required</mat-error>
             
            </span>     
        </div>
    </div>

    <div class="ttmodal__footer">
        <!-- <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a> -->
        <!-- <a class="button" [class.button--primary]="!customerNameInput.errors && !emailInput.errors"   [class.loading]="saving"    (click)="saveChanges()"><span class="button__text">Send</span></a> -->
        <button mat-raised-button (click)="onCloseClick()">Cancel</button>
        <button mat-raised-button color="warn" [class.loading]="saving"  (click)="saveChanges()"   [disabled]= "emailInput.errors || customerNameInput.errors || !validEmailString">
            <span class="material-icons button__icon">check</span>
            <span class="button__text">Send</span>
        </button>
 
    </div>
</div>
